import request from './service/index';

// 课程分类 
export function addLectureTopics_Api(data){
    return request({
        url:'CMS/lecture/lecture_classification',
        method:'post',
        data:data
    });
}
export function deleteLectureTopics_Api(data){
    return request({
        url:'CMS/lecture/lecture_classification',
        method:'delete',
        data:data
    });
}
export function updateLectureTopics_Api(data){
    return request({
        url:'CMS/lecture/lecture_classification',
        method:'put',
        data:data
    });
}
export function getLectureTopics_Api(){
    return request({
        url:'CMS/lecture/lecture_classification',
        method:'get',
    });
}

// 课程详情
export function addLecture_Api(data){
    return request({
        url:'CMS/lecture/lecture_detail',
        method:'post',
        data:data
    });
}
export function deleteLecture_Api(data){
    return request({
        url:'CMS/lecture/lecture_detail',
        method:'delete',
        data:data
    });
}
export function updateLecture_Api(data){
    return request({
        url:'CMS/lecture/lecture_detail',
        method:'put',
        data:data
    });
}
export function getLecture_Api(id){
    return request({
        url:`CMS/lecture/lecture_detail?lecture_id=${id}`,
        method:'get',
    });
}

// 课程系列
export function addLectureSeries_Api(data){
    return request({
        url:'CMS/lecture/lecture_series',
        method:'post',
        data:data
    });
}
export function deleteLectureSeries_Api(data){
    return request({
        url:'CMS/lecture/lecture_series',
        method:'delete',
        data:data
    });
}
export function updateLectureSeries_Api(data){
    return request({
        url:'CMS/lecture/lecture_series',
        method:'put',
        data:data
    });
}
export function getLectureSeries_Api(id){
    return request({
        url:`CMS/lecture/lecture_series?series_id=${id}`,
        method:'get',
    });
}
export function getLectureSeriesList_Api(page){
    return request({
        url:`CMS/lecture/lecture_series_list?page=${page}`,
        method:'get',
    });
}


// 课程视频
export function addLectureVideo_Api(data){
    return request({
        url:'CMS/lecture/lecture_video',
        method:'post',
        data:data
    });
}
export function deleteLectureVideo_Api(data){
    return request({
        url:'CMS/lecture/lecture_video',
        method:'delete',
        data:data
    });
}
export function updateLectureVideo_Api(data){
    return request({
        url:'CMS/lecture/lecture_video',
        method:'put',
        data:data
    });
}
export function getLectureVideo_Api(id){
    return request({
        url:`CMS/lecture/lecture_video?lecture_id=${id}`,
        method:'get',
    });
}

// 课程数量
export function getLectureCount_Api(){
    return request({
        url:'CMS/lecture/lecture_count',
        method:'get',
    });
}

// 下拉框选项
export function lectureSeriesDropDown_Api(){
    return request({
        url:`/CMS/tools/lecture_series_drop_down`,
        method:'get',
    })
}
export function lectureScholarDropDown_Api(keyword){
    return request({
        url:`/CMS/tools/scholar_search_box?keyword=${keyword}`,
        method:'get',
    })
}
export function lectureClassificationDropDown_Api(){
    return request({
        url:`/CMS/tools/lecture_classification_drop_down`,
        method:'get',
    })
}
export function lectureUniversityDropDown_Api(keyword){
    return request({
        url:`/CMS/tools/university_search_box?keyword=${keyword}`,
        method:'get',
    })
}

// 课程列表
export function getLectureList_Api(data){
    return request({
        url:`/CMS/lecture/lecture_list`,
        method:'post',
        data:data
    })
}

export function deleteLectureList_Api(data){
    return request({
        url:`/CMS/lecture/lecture_list`,
        method:'delete',
        data:data
    })
}

export function outputLecture_Api(data){
    return request({
        url:'CMS/lecture/output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}


// WEBPACK FOOTER //
// ./src/apis/lecture.api.js